import React from "react";
import {ColletteButton} from "@collette-travel/collette-common-controls";
import {Stack, Typography} from "@mui/material";

interface NoResultsProps {
  header: string;
  buttonLabel: string;
  onClick: () => void;
}

const NoSearchResults = ({
  header,
  buttonLabel,
  onClick
}: NoResultsProps) => (
    <Stack
      sx={{
        flexDirection: "column",
        gap: "3rem",
        alignItems: "center"
      }}
    >
      <Typography
        variant="h4"
        textAlign="center"
        data-testid="no-search-results-text"
      >
        {header}
      </Typography>
      <ColletteButton
        color="primary"
        label={buttonLabel}
        testId="no-search-results-button"
        onClick={onClick}
      />
    </Stack>
  );

export default NoSearchResults;